/**
 * Trailblazers treasure artwork — bundled icons for rewards that carry no
 * uploaded image of their own.
 *
 * A Cartel reward brings its catalogue icon url and a custom one reuses the map
 * markers, so only the fixed reward kinds need art here. The ids live in
 * `@swtorbit/shared-socket-events` (`TRL_TREASURE_ICON_ASSETS`), which the Node
 * API server imports and which therefore can carry no image imports; this module
 * is the visual half of that pair, exactly as `trlSabotageIcons.ts` is for the
 * sabotage registry.
 *
 * `TrlTreasureIconAsset` is imported as a TYPE ONLY, so this stays a pure asset
 * module with no runtime dependency, while the `Record` still fails to compile
 * the moment an id is added without artwork.
 *
 * The emoji on the row (`icon.glyph`) remains the fallback for a file that fails
 * to load.
 *
 * To add one: drop the webp in `served/trl/rewards/`, add the id to
 * `TRL_TREASURE_ICON_ASSETS`, run `npm run publish:art`, and add one entry
 * below.
 */
import { artUrl } from './art';
/**
 * Artwork per reward id. Authored large with a transparent background — it is
 * always sized down at the point of use (`.trl-treasure__icon-img` fits it to
 * the same 43px frame a Cartel icon gets), never rendered at source resolution.
 *
 * `augment` is currently a PLACEHOLDER: a copy of the credits coin, standing in
 * until its own artwork is drawn. Nothing but this file needs to change when it
 * is — swap `served/trl/rewards/augment.webp` and delete this note.
 *
 * Exhaustive: a new reward kind without artwork does not compile.
 */
export const TRL_TREASURE_ICONS = {
    credits: 'trl/rewards/credits.webp',
    augment: 'trl/rewards/augment.webp',
};
/**
 * The icon for a reward id, or `''` for an unknown/absent one so a caller can
 * fall back without guarding first (an `<img src="">` renders nothing).
 */
export function getTrlTreasureIconUrl(asset) {
    if (!asset)
        return '';
    const art = TRL_TREASURE_ICONS[asset];
    return art ? artUrl(art) : '';
}
